import classNames from "classnames";
import type React from "react";
import { NavLink } from "react-router-dom";
import "./List.css";

type Props = {
    className?: string;
    children: React.ReactNode;
};

function TabList(props: Props) {
    const { children, className } = props;
    return <div className={classNames("tab list-tab", className)}>{children}</div>;
}

function TabListHeader(props: Props) {
    const { children, className } = props;
    return <div className={classNames("tab-list-header", className)}>{children}</div>;
}

function ListHeader(props: Props) {
    const { children, className } = props;
    return <div className={classNames("list-header", className)}>{children}</div>;
}

function ListHeaderColumn(props: Props) {
    const { children, className } = props;
    return (
        <div className={classNames("list-header__column", className)}>{children}</div>
    );
}

type ListItemProps = {
    id: string;
    link?: string;
} & Props;

export function ListItem(props: ListItemProps) {
    const { children, className, id, link } = props;
    return link ? (
        <NavLink
            id={id}
            className={classNames("list-item", className)}
            to={link}
            activeClassName="selected"
        >
            {/* @ts-ignore we are using outdated libraries that use ReactNode instead of JSX.Element. */}
            {children}
        </NavLink>
    ) : (
        <div id={id} className={classNames("list-item", className)}>
            {children}
        </div>
    );
}

function ListItemColumn(props: Props) {
    const { children, className } = props;
    return <div className={classNames("list-item__column", className)}>{children}</div>;
}

function ListItemColumnContainer(props: Props) {
    const { children, className } = props;
    return (
        <div className={classNames("list-item__column-container", className)}>
            {children}
        </div>
    );
}

export const List = {
    Tab: TabList,
    TabHeader: TabListHeader,
    Header: ListHeader,
    HeaderColumn: ListHeaderColumn,
    Item: ListItem,
    ItemColumn: ListItemColumn,
    ItemColumnContainer: ListItemColumnContainer,
};
